<div class="isp-page__social">
  <div class="isp-social__delimiter">
    <span class="isp-social__delimiter__label">
      {{ socialTitleMessage }}
    </span>
  </div>
  <div class="isp-social__links">
    <a
      *ngFor="let link of imageLinks"
      [href]="link.href"
      class="isp-social__link"
    >
      <img class="isp-social__icon" [src]="baseDir + link.name + '.svg'" />
    </a>
  </div>
</div>
